import {ConfigService, Field, Tracker} from 'shared';
import {ModelsList, StoreService} from 'shared';
import {Observable} from 'rxjs';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ErrorsService} from 'shared';
import {TrackerAssignment} from 'shared';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TrackerService extends StoreService<Tracker> {


  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Tracker);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Tracker>> {
    return this.http.get<ModelsList<Tracker>>(this.config.apiVerUrl('/app/trackers'), {params: queryParams});
  }

  protected insert(values: Tracker): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/trackers'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/trackers/${id}`));
  }

  protected update(id, values): Observable<Tracker> {
    return this.http.put<Tracker>(this.config.apiVerUrl(`/app/trackers/${id}`), values);
  }

  public checkIMEI(imei: number, id?: number): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl('/app/trackers/check-imei'), {imei, id});
  }

  public assignments(id): Observable<ModelsList<TrackerAssignment>> {
    return this.http.get<ModelsList<TrackerAssignment>>(this.config.apiVerUrl(`/app/trackers/${id}/assignments`));
  }
}
